/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-quotes */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useRef, useState } from 'react';
import { StyleSheet, View, FlatList, InteractionManager } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { theme } from '../../theme/theme';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Searchbar } from 'react-native-paper';
import CategoryItems from './CategoryItems';
import { doGet } from '../../services/http';
import { errorHandler } from '../../services/Utils';
import { hideLoader, showLoader } from '../../store/info.slice';
import { fetchCafe } from '../../store/cafe.slice';


function Menu({ navigation, route }) {
    const dispatch = useDispatch();
    const flatListRef = useRef(null);

    const canteens = useSelector(state => state.cafe.canteens);
    const [interactionCompleted, setIntersectionCompleted] = useState(false);
    const [categories, setCategories] = useState([]);
    const [items, setItems] = useState([]);
    const [counter, setCounter] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [isCounterUpdated, setCounterUpdated] = useState(false);

    const getCanteenMenu = (canteen_id) => {
        dispatch(showLoader());
        doGet('full-menu', { canteen_id }).then(response => {
            dispatch(hideLoader());
            setCategories(response?.data?.categories || []);
            setItems(response?.data?.items);
            setCounter(response?.data?.canteen);
        }).catch(errorHandler);
    };

    useEffect(() => {
        const task = InteractionManager.runAfterInteractions(async () => {
            setIntersectionCompleted(true);
        });
        return () => {
            task.cancel();
        };
    }, []);

    useEffect(() => {
        return () => {
            if (isCounterUpdated) {
                dispatch(fetchCafe());
            }
        };
    }, [interactionCompleted, isCounterUpdated]);

    useEffect(() => {
        if (interactionCompleted) {
            if (canteens?.length > 0) {
                getCanteenMenu(canteens[0]?.canteen_id);
            } else {
                dispatch(fetchCafe());
            }
        }
    }, [interactionCompleted, canteens]);

    const renderCanteenItem = ({ item, index }) => {
        return (
            <View style={{ flex: 1, padding: 2 }}>
                <Button onPress={() => getCanteenMenu(item?.canteen_id)} mode={counter?.canteen_id === item?.canteen_id ? 'contained' : 'outlined'}>{item?.canteen_name}</Button>
            </View>
        );
    };
    const renderItem = ({ item, index }) => <CategoryItems onUpdateItemStatus={onUpdateItemStatus} onUpdateItemStockQty={onUpdateItemStockQty} onUpdateCategoryStatus={onUpdateCategoryStatus} _items={items} searchQuery={searchQuery} counter={counter} category={item} />;

    const onUpdateCategoryStatus = (payload) => {
        const { category_id, category_status, prevent_item_status_update_on_category_status_change = false } = payload;
        const index = categories.findIndex(item => Number(item.category_id) === Number(category_id));
        if (index !== -1) {
            const temp = [...categories];
            temp[index] = { ...temp[index], category_status };
            setCategories([...temp]);
            if (!prevent_item_status_update_on_category_status_change) {
                if (category_status === false) {
                    setItems(items.map(item => Number(item.category_id) === Number(category_id) ? { ...item, item_status: false } : item));
                }
            }
            setCounterUpdated(true);
        }
    };

    const onUpdateItemStatus = (payload) => {
        const { item_id, item_status } = payload;
        const index = items.findIndex(item => Number(item.item_id) === Number(item_id));
        if (index !== -1) {
            const temp = [...items];
            temp[index] = { ...items[index], item_status };
            setItems(temp);
            setCounterUpdated(true);
        }
    };

    const onUpdateItemStockQty = (payload) => {
        setCounterUpdated(true);
    };

    return (
        <SafeAreaView edges={['bottom']} style={styles.container}>
            {interactionCompleted &&
                <React.Fragment>
                    <View style={styles.mainContainer}>
                        <View style={{ margin: 2, marginBottom: 4 }}>
                            <FlatList
                                horizontal={true}
                                data={canteens}
                                renderItem={renderCanteenItem}
                                keyExtractor={(item, index) => (item?.canteen_id).toString()}
                                style={{ paddingVertical: 2 }}
                            />
                            <Searchbar
                                placeholder="Search"
                                onChangeText={setSearchQuery}
                                value={searchQuery}
                            />
                        </View>
                        {counter &&
                            <React.Fragment>
                                <FlatList
                                    ref={flatListRef}
                                    data={categories}
                                    renderItem={renderItem}
                                    keyExtractor={(item, index) => (item?.category_id).toString()}
                                />
                            </React.Fragment>
                        }
                    </View>
                </React.Fragment>
            }
        </SafeAreaView >
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#f1f1f3',
    },
    mainContainer: {
        flex: 1,
        margin: 4,
    },
    countersContainer: {
        flex: 1,
        borderRadius: 8,
        padding: 8,
        margin: 4,
    },
    recommendedContainer: {
        // flex: 1,
        borderRadius: 8,
        padding: 8,
        margin: 4,
    },
    slideContainer: {
        flex: 1,
        height: 144,
        margin: 4,
        borderRadius: 8,
        backgroundColor: '#ffffff',
    },
    slide: {
        backgroundColor: 'rgba(20,20,200,0.3)',
        height: 200,
        width: '100%',
    },
    br6: {
        borderWidth: 1,
        borderColor: '#f1f1f3',
        borderBottomEndRadius: 6,
        borderBottomStartRadius: 6,
    },
    item: {
        flex: 1, marginVertical: 4, paddingHorizontal: 4,
    },
    coverImage: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        backgroundColor: '#ffffff',
    },
    ribbon: {
        position: 'absolute',
        top: 0,
        left: 0,
        paddingVertical: 2,
        paddingHorizontal: 6,
        borderTopLeftRadius: 6,
        backgroundColor: theme.colors.primary,
    },
    fabStyle: {
        bottom: 16,
        right: 20,
        position: 'absolute',
        borderRadius: 64,
    },
});

export default Menu;
